import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchInsightsTableData } from 'stores/queries/support-workers/support-workers-queries';
import { InsightsTableRequest, InsightsTableResponse } from 'views/insights/insights';

export const useFetchInsightsTable = (request: InsightsTableRequest): UseQueryResult<InsightsTableResponse> => {
  return useQuery(['fetchInsightsTable', JSON.stringify(request)], () => fetchInsightsTableData(request));
};
